import { axios } from '@/utils/request'

export const mallListPage = (categoryId, pageNum, pageSize) => {
  return axios.get(`/api/web/mall/mall/listPage?categoryId=${categoryId}&pageNum=${pageNum}&pageSize=${pageSize}`)
}

export const partListPage = (categoryId, pageNum, pageSize) => {
  return axios.get(`/api/web/biz/parts/list?categoryId=${categoryId}&pageNum=${pageNum}&pageSize=${pageSize}`)
}
